import { createStyles, makeStyles } from "@material-ui/core"
import { FC, useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { useRecoilState } from "recoil"
import { buildClientDetailPath } from "../../hooks/useNavigation"
import { useStorage } from "../../hooks/useStorage"
import { sessionState } from "../../utils/store"
import Logo from "../atoms/Logo"
import { BaseTemplate } from "../templates/BaseTemplate"

/**
 * Styles for the ExternalSSO component.
 */
const useStyles = makeStyles((theme) =>
  createStyles({
    logo: {
      position: "absolute",
      top: theme.spacing(6),
      left: theme.spacing(6),
    },
  })
)

/**
 * ExternalSSO component handles authentication via external Single Sign-On (SSO).
 *
 * - Extracts authentication parameters from the URL query string.
 * - Stores session data using Recoil and local storage.
 * - Redirects authenticated users to the client detail page.
 *
 * @component
 * @returns {JSX.Element} The rendered ExternalSSO screen.
 */
const ExternalSSO: FC = () => {
  const history = useHistory()
  const { search } = useLocation()
  const queryParams = new URLSearchParams(search)
  const token = queryParams.get("token")
  const userId = queryParams.get("userId")
  const role = queryParams.get("role")
  const clientId = queryParams.get("clientId")
  const [session, setSession] = useRecoilState(sessionState)
  const { storeSession } = useStorage()

  const classes = useStyles()

  /**
   * Effect to handle SSO authentication and session storage.
   * Redirects to client detail page after storing session.
   */
  useEffect(() => {
    if (token && userId && role && clientId) {
      const data = {
        jwt: token,
        userId: userId,
        role: role,
      }
      storeSession(data)
      setSession(data)
      history.push(buildClientDetailPath(clientId, undefined, "?partner=true"))
    }
  }, [token, userId, role, clientId, storeSession, setSession, history])

  return (
    <>
      <BaseTemplate>
        <div>
          <Logo className={classes.logo} />
          <h1>External SSO</h1>
        </div>
      </BaseTemplate>
    </>
  )
}

export default ExternalSSO
